import * as React from 'react';
import { useState, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { ZIndex } from '@lean-body/src/view/constants';
import { useSmMediaQuery } from '@lean-body/src/util/media_query_hooks';
import { GoalMatchingAssessment, PageLoading } from '@lean-body/components/organisms';
import { Logo } from '@lean-body/components/atoms';
import { KIND_WEIGHT, } from '@lean-body/src/domain';
import { useQuery } from '@lean-body/src/util';
export const GOAL_MATCHING_ASSESSMENT_VERSION = 8;
export const GoalMatchingAssessmentPageQuery = {
    new: 'new',
    change: 'change',
};
/**
 * 目標診断設定ページ
 */
export const GoalMatchingAssessmentPage = ({ apiClient, config, setProfile, }) => {
    const isSM = useSmMediaQuery();
    const query = useQuery();
    const [assessments, setAssessments] = useState();
    const [answers, setAnswers] = useState();
    const [isReassessment, setIsReassessment] = useState(!!query.get(GoalMatchingAssessmentPageQuery.change));
    const skipToKind = isReassessment ? KIND_WEIGHT : null;
    const [showStartPage, setShowStartPage] = useState(!isReassessment);
    useEffect(() => {
        apiClient
            .fetchGoalMatchingAssessmentAnswerCheck(GOAL_MATCHING_ASSESSMENT_VERSION)
            .then((answeredRequiredFields) => {
            if (isReassessment && !answeredRequiredFields) {
                setIsReassessment(false);
                setShowStartPage(false);
            }
            apiClient.fetchGoalMatchingAssessments(GOAL_MATCHING_ASSESSMENT_VERSION).then(setAssessments);
            apiClient.fetchGoalMatchingAssessmentAnswer(GOAL_MATCHING_ASSESSMENT_VERSION).then(setAnswers);
        });
    }, []);
    if (!(assessments && answers)) {
        return React.createElement(PageLoading, null);
    }
    return (React.createElement("div", { className: css(styles.container) },
        isSM && React.createElement(Logo, { forHeader: isSM, classObject: styles.logo }),
        React.createElement(GoalMatchingAssessment, { apiClient: apiClient, config: config, setProfile: setProfile, assessments: assessments, pastAnswers: answers, isReassessment: isReassessment, showStartPage: showStartPage, skipToKind: skipToKind })));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        width: '100%',
        height: '100vh',
    },
    logo: {
        position: 'fixed',
        width: '100%',
        backgroundColor: Colors.White,
        zIndex: ZIndex.Header,
    },
});
